import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-switch-to-offline-confirmation-dialog",
  templateUrl: "./switch-to-offline-confirmation-dialog.component.html",
  styleUrl: "./switch-to-offline-confirmation-dialog.component.scss",
  standalone: false
})
export class SwitchToOfflineConfirmationDialogComponent {
  constructor(public dialogRef: MatDialogRef<SwitchToOfflineConfirmationDialogComponent>) {}

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
